import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withT } from "~app/BundleProvider";

class Attachment extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    index: PropTypes.number,
    fileName: PropTypes.string.isRequired,
  }

  handleClick = () => {
    this.props.onRemoveClick(this.props.fileName);
  }

  render() {
    const { fileName, t } = this.props;

    return (
      <div className="attachments__attachment"
      role="button"
      tabIndex="0"
      onClick={this.handleClick}
      onKeyPress={(event) => {
        if(event.key === 'Enter' || event.key === ' '){
          this.handleClick();
        }
      }}>
        {fileName}
        <img

          className="attachments__delete-icon"
          src={require("~app/resources/images/icons/DeleteIcon.svg")}
          alt={t("remove")}

        />
      </div>
    );
  }
}

export default withT(Attachment);



// WEBPACK FOOTER //
// ./src/components/Attachment.js